import React from 'react'
import PropTypes from 'prop-types'

export default class FormErrorBubble extends React.Component {

  static propTypes = {
    /**
     * Input ValidityState
     */
    validity:  PropTypes.object,
    validates: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: 'error-bubble',
  }



  valid() {
    // Assume valid till we have a ValidityState object. We dont want to flash
    // errors.
    if (!this.props.validity) {
      return true
    }

    const validity  = this.props.validity
    const validates = this.props.validates

    return validates ? validity[validates] : validity.valid
  }

  render() {
    return !this.valid() && (
      <span className={ this.props.className }>
        <span className="error-msg">{ this.props.children }</span>
        <span className="error-arrow"></span>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./client/Components/Form/ErrorBubble/ErrorBubble.jsx